document.addEventListener('DOMContentLoaded', function () {
    let mySwiper = new Swiper('.comment-container .swiper-comment-list', {
        loop: true,
        autoplay: {
            delay: 2000,
        },
        slidesPerView: 40,
        slidesPerView: 4,
        breakpoints: {
            300: {
                slidesPerView: 1,
                spaceBetween: 20,
            },
            650: {
                slidesPerView: 2,
                spaceBetween: 20,
            },
            1000: {
                slidesPerView: 3,
                spaceBetween: 20,
            },
            1200: {
                slidesPerView: 4,
                spaceBetween: 20,
            },
        },
        navigation: {
            nextEl: '.comment-container .swiper-button-next',
            prevEl: '.comment-container .swiper-button-prev',
        },
    });
});